module.exports = __webpack_public_path__ + "static/media/inbox-in.720d65de.svg";